const backlisteners: Array<() => void> = [];
const forwardlisteners: Array<() => void> = [];

const onPopState = (event: PopStateEvent): void => {
    if (!event.state || !event.state.action) {
        return;
    }

    switch (event.state.action) {
        case 'back':
            backlisteners.length && backlisteners.forEach((f) => f());
            window.history.forward();
            break;
        case 'forward':
            forwardlisteners.length && forwardlisteners.forEach((f) => f());
            window.history.back();
            break;
    }
}    

const validatePlatform = () : boolean =>
{
    // On iOS, this doesn't work on Chrome
    if (!navigator.platform || !/iPad|iPhone|iPod/.test(navigator.platform)){
        return true;
    }

    if (!navigator.userAgent || !/CriOS/.test(navigator.userAgent)) {
        return true;
    }
    return false;
}

const getLaunchPath = () => {
    return  window.location.href;
}

const registerEventHandlers = (onBack: () => void, onForward: () => void): void => {
    backlisteners.push(onBack);
    forwardlisteners.push(onForward);
}

const startNavigation = () => {
    if (!validatePlatform()) {
        return;
    }

    const orig = getLaunchPath();
    // const title = windowActions.getTitle();
    const title = '';
    window.history.replaceState({ action: 'back' }, title, window.location.href + '#back');
    window.history.pushState({ action: 'current' }, title, orig);
    window.history.pushState({ action: 'forward' }, title, window.location.href + '#forward');
    window.history.back();

    window.addEventListener('popstate', onPopState);
}

const endNavigation = () => {
    window.removeEventListener('popstate', onPopState);
}

export {
    startNavigation,
    endNavigation,
    registerEventHandlers
}